import _ from 'lodash';
import queryString from 'query-string';

/**
 * When adding routes here don't forget to associate the route with a view
 * in /src/components/App/Routes.jsx.
 */

// Ingredients
export const newIngredientsRoute = () => '/ingredients/new';

export const newGlobalIngredientsRoute = () => '/ingredients/new/global';

export const excludedIngredientsRoute = () => '/ingredients/excluded';

// PPIs
export const draftPPIsRoute = () => '/ppis/draft';

export const publishedPPIsRoute = () => '/ppis/published';

export const globalSearchRoute = query =>
  query ? `/search?search=${query}` : '/search';

export const ppiCreateRoute = itemCode => {
  return itemCode ? `/ppis/create?itemCode=${itemCode}` : '/ppis/create';
};

export const ppiCreateFromExistingSelectPpiRoute = (
  fromPpsiId,
  itemCode,
  localPpiCopy
) =>
  itemCode && fromPpsiId && localPpiCopy
    ? `/ppis/createFromExisting/selectPpi?itemCode=${itemCode}&fromPpsiId=${fromPpsiId}&localPpiCopy=${localPpiCopy}`
    : '/ppis/createFromExisting/selectPpi';

export const ppiCreateFromExistingRoute = (
  fromPpiId,
  fromEnrichmentId,
  itemCode,
  localPpiCopy
) =>
  fromPpiId && fromEnrichmentId && itemCode
    ? `/ppis/createFromExisting?fromPpiId=${fromPpiId}&fromEnrichmentId=${fromEnrichmentId}&itemCode=${itemCode}&localPpiCopy=${localPpiCopy}`
    : '/ppis/createFromExisting';

// ppi create from published lists

export const ppiCreateFromPublishedPpiRoute = (itemCode, localPpiCopy) =>
  itemCode && localPpiCopy
    ? `/ppis/publishedPpi?itemCode=${itemCode}&localPpiCopy=${localPpiCopy}`
    : '/ppis/publishedPpi';

export const ppiInProgressRoute = id => `/ppis/${id}/inprogress`;

export const ppiCreateVariantRoute = (id, itemCode, status) => {
  return id && itemCode
    ? `/ppis/createVariant?id=${id}&itemCode=${itemCode}&status=${status}`
    : '/ppis/createVariant';
};

// export const globalVariantPpiRoute = (fromPpiId, id, itemCode, status) => {
//   return fromPpiId && id
//     ? `/ppis/globalPpiVariant?fromPpiId=${fromPpiId}&id=${id}&itemCode=${itemCode}&status=${status}`
//     : '/ppis/globalPpiVariant';
// };

export const ppiPublishedRoute = id => `/ppis/${id}`;

// Updates
export const updatesRoute = () => '/updates';
// upload

// export const newUpdatesRoute = () => '/new-updates';

//upload
export const uploadFileRoute = () => '/upload';
// Dishes

export const newDishesRoute = () => '/dishes/new';

export const newGlobalDishesRoute = () => '/dishes/new/global';

export const excludedDishesRoute = () => '/dishes/excluded';

// PPSIs
export const draftPPSIsRoute = () => '/ppsis/draft';

export const approvedPPSIsRoute = () => '/ppsis/scheduled';

export const approvalStatusPPSIsRoute = () => '/approvalStatus';

export const dataReportRoute = () => '/dataReports';

export const totalRangeDishStatisticsRoute = id => '/totalRangeDishStatistics';

export const coWorkerEngagementReportMarketRoute = id =>
  `/coWorkerEngagementReport`;
export const coWorkerEngagementReportRoute = id =>
  `/coWorkerEngagementReport/${id}`;
export const coWorkerEngagementReportListRoute = () =>
  '/coWorkerEngagementReportListView';

export const globalWaitingReviewRoute = () => '/waitingreview';

export const globalMarketReviewRoute = id => `/waitingreview/ppsis/${id}`;

export const globalReviewApprovalRoute = id =>
  `/waitingreview/ppsis/${id}/globalapproval`;

export const globalPpsisRoute = () => '/global-ppsis';

export const publishedPPSIsRoute = () => '/ppsis/published';

export const ppsiCreateRoute = formulaCode => {
  return formulaCode
    ? `/ppsis/create?formulaCode=${formulaCode}`
    : '/ppsis/create';
};
export const ppsiCreateFromPublishedPpsiRoute = (formulaCode, localPpsiCopy) =>
  formulaCode && localPpsiCopy
    ? `/ppsis/publishedPpsi?formulaCode=${formulaCode}&localPpsiCopy=${localPpsiCopy}`
    : '/ppsis/publishedPpsi';

export const ppsiCreateVariantRoute = (id, formulaCode, status) => {
  return id && formulaCode
    ? `/ppsis/createVariant?id=${id}&formulaCode=${formulaCode}&status=${status}`
    : '/ppsis/createVariant';
};

export const ppsiCreateFromExistingRoute = (
  formulaCode,
  fromPpsiId,
  fromEnrichmentId,
  localPpsiCopy
) =>
  formulaCode && fromPpsiId && fromEnrichmentId
    ? `/ppsis/createFromExisting?formulaCode=${formulaCode}&ppsiId=${fromPpsiId}&enrichmentId=${fromEnrichmentId}&localPpsiCopy=${localPpsiCopy}`
    : '/ppsis/createFromExisting';

export const ppsiInProgressRoute = id => `/ppsis/${id}/inprogress`;

export const ppsiPublishedRoute = id => `/ppsis/${id}`;

// Approval waiting from global admin

export const approvalPedningMarketRoute = marketCode => `/ppsis/${marketCode}`;
export const approvalPedningDishRoute = (marketCode, id) =>
  `/ppsis/${marketCode}/${id}/inprogress`;

// Other
export const searchProductsRoute = () => '/search';

export const unpublishedPpsisRoute = () => '/unpublishedppsis';

export const unpublishedPpisRoute = () => '/unpublishedppis';

// feedback
export const feedbackRoute = () => '/feedback';

// Authentication
export const loginRoute = queryParams => {
  if (_.isEmpty(queryParams)) {
    return `/login`;
  }
  return `/login?${queryString.stringify(queryParams)}`;
};

export const authRoute = () => '/auth';

export const logoutRoute = () => '/logout';

// NIR specific routes

const nirMarketBaseRoute = marketCode => `/nir/${marketCode}`;

export const bomReportNirRoute = marketCode =>
  `${nirMarketBaseRoute(marketCode)}/bomreport`;

export const globalPpsisNirRoute = marketCode =>
  `${nirMarketBaseRoute(marketCode)}/ppsis/global`;

export const globalPppsiDetailsNirRoute = (marketCode, id) =>
  `/admin/dppsi/${marketCode}/ppsis/global/${id}`;

export const ppsiCreateFromGlobalNirRoute = (
  marketCode,
  formulaCode,
  fromPpsiId,
  fromEnrichmentId,
  globalPiaArticleNumber
) =>
  formulaCode && fromPpsiId && fromEnrichmentId
    ? `${nirMarketBaseRoute(
        marketCode
      )}/ppsis/createFromGlobal?formulaCode=${formulaCode}&ppsiId=${fromPpsiId}&enrichmentId=${fromEnrichmentId}&globalPiaArticleNumber=${globalPiaArticleNumber}`
    : `${nirMarketBaseRoute(marketCode)}/ppsis/createFromGlobal`;

export const marketSettingsRoute = () => `/marketSettings`;
